<template>
  <div class="process-bar">
    <div
      class="process-item"
      v-for="(item, index) in data"
      :key="index"
      :style="getStyle(index)"
      @click="onClick(item)"
      :class="{ 'blue--deep': value === index, blue: value > index }"
    >
      {{ item.name }}
      <div class="arrow">
        <div class="arrow-bg"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getStyle(index) {
      const zIndex = 1000 - index;
      return {
        'z-index': zIndex
      };
    },
    onClick(item) {
      this.$emit('input', item.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.process-bar {
  // 241
  // 224
  width: 100%;
  height: 32px;
  background: #f5f5f5;
  .process-item {
    float: left;
    width: 25%;
    position: relative;
    text-align: center;
    font-size: 12px;
    color: #495057;
    line-height: 32px;
    font-weight: bold;
    padding-left: 8px;

    &.blue {
      background: #3daee6;
      color: #fff;
      .arrow-bg {
        background: #3daee6;
      }
    }

    &.blue--deep {
      background: rgba(13, 154, 224, 1);
      color: #fff;
      .arrow-bg {
        background: rgba(13, 154, 224, 1);
      }
    }

    .arrow {
      $arrowWidth: 16px;
      position: absolute;
      height: 32px;
      width: $arrowWidth;
      top: 0;
      right: -1 * $arrowWidth;
      overflow: hidden;
      .arrow-bg {
        content: " ";
        position: absolute;
        width: 32px;
        height: 32px;
        top: 0;
        right: 6px;
        border: 1px solid #fff;
        transform: rotate(45deg);
      }
    }
  }
}
</style>
